import { removeItem } from './webStorage';
import { FinanceCalculatorStorageState } from '../types';

function cleanUpFinanceCalculatorStorageData(): void {
  Object.keys(FinanceCalculatorStorageState).forEach((key) => removeItem(key));
}

export default cleanUpFinanceCalculatorStorageData;
